import { DollarSign, TrendingUp, TrendingDown } from 'lucide-react';

export default function CostingTab({ costing }) {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-stone-900">Análisis de Costos</h1>

      {/* Summary */}
      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white rounded-2xl p-6 border border-stone-200">
          <p className="text-sm text-stone-500">Margen Promedio</p>
          <p className="text-2xl font-bold text-emerald-700">
            {costing.avg_margin?.toFixed(1) || 0}%
          </p>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-stone-200">
          <p className="text-sm text-stone-500">Productos Analizados</p>
          <p className="text-2xl font-bold text-stone-900">
            {costing.products?.length || 0}
          </p>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-stone-200">
          <p className="text-sm text-stone-500">Ganancia Potencial</p>
          <p className="text-2xl font-bold text-emerald-700">
            ${(costing.total_potential_profit || 0).toLocaleString()}
          </p>
        </div>
      </div>

      {/* Products Table */}
      <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-stone-50 border-b border-stone-200">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Producto</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Precio Venta</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Costo</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Margen $</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Margen %</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {costing.products?.map(product => {
                const marginPercent = product.margin_percent || 
                  (product.price > 0 ? ((product.price - product.cost) / product.price * 100) : 0);
                const margin = product.margin || (product.price - product.cost);
                const isLowMargin = marginPercent < 30;
                
                return (
                  <tr key={product.product_id} className="hover:bg-stone-50">
                    <td className="px-4 py-3">
                      <span className="font-medium text-stone-900">{product.name}</span>
                    </td>
                    <td className="px-4 py-3 text-stone-700">${product.price?.toLocaleString()}</td>
                    <td className="px-4 py-3 text-stone-500">${product.cost?.toLocaleString()}</td>
                    <td className="px-4 py-3">
                      <span className={`font-semibold ${margin >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>
                        ${margin?.toFixed(2)}
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <span className={`font-semibold ${isLowMargin ? 'text-orange-600' : 'text-emerald-700'}`}>
                          {marginPercent?.toFixed(1)}%
                        </span>
                        {marginPercent >= 0 ? (
                          <TrendingUp className={`w-4 h-4 ${isLowMargin ? 'text-orange-500' : 'text-emerald-500'}`} />
                        ) : (
                          <TrendingDown className="w-4 h-4 text-red-500" />
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {(!costing.products || costing.products.length === 0) && (
          <div className="text-center py-12 text-stone-500">
            No hay datos de costeo disponibles
          </div>
        )}
      </div>
    </div>
  );
}
